// CarePillarsSection.js
import React from "react";
import { Link } from "react-router-dom";
import { Heart, LifeBuoy, Users, ArrowRight } from "lucide-react";

const CarePillarsSection = () => {
  return (
    <section className="bg-white pb-8 md:pb-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 items-start">
          {/* Living with Care */}
          <div className="text-center px-8 py-10">
            <span className="inline-flex items-center justify-center w-14 h-14 rounded-full border border-bnBorder text-bnAccent mb-6">
              <Heart size={22} strokeWidth={1.5} />
            </span>
            <h3 className="text-bnInk font-medium text-lg mb-2">
              Living with Care
            </h3>
            <p className="text-bnBody text-sm leading-relaxed">
              Support and resources for residents, families, and carers.
            </p>
          </div>

          {/* Support for Care Teams (highlighted) */}
          <div className="text-center px-8 py-10 bg-bnCream rounded-2xl">
            <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-bnAccent text-white mb-6">
              <LifeBuoy size={22} strokeWidth={1.5} />
            </span>
            <h3 className="text-bnInk font-medium text-lg mb-2">
              Support for Care Teams
            </h3>
            <p className="text-bnBody text-sm leading-relaxed">
              Training and tools to help carers deliver safe, high-quality care.
            </p>
            {/* Careers temporarily hidden from public access
           <Link
             to="/careers"
             className="inline-flex items-center gap-2 bg-white text-bnInk hover:text-bnAccent font-medium text-sm px-6 py-3 rounded-full shadow-sm transition-colors"
           >
             Learn More
             <ArrowRight size={16} />
           </Link>
           */}
          </div>

          {/* Partnering with Providers */}
          <div className="text-center px-8 py-10">
            <span className="inline-flex items-center justify-center w-14 h-14 rounded-full border border-bnBorder text-bnAccent mb-6">
              <Users size={22} strokeWidth={1.5} />
            </span>
            <h3 className="text-bnInk font-medium text-lg mb-2">
              Partnering with Providers
            </h3>
            <p className="text-bnBody text-sm leading-relaxed">
              Guidance and standards for delivering compliant, trusted services.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CarePillarsSection;
